import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import toast, { Toaster } from "react-hot-toast";
import { createPoints, updatePoints } from "../../API/points";
import { IKImage, IKContext, IKUpload } from "imagekitio-react";
import "./addNewCard.css";
import "./upload-help.ts";
import Upload from "../../icons/upload";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../helpers/toasters";
import { imageKitPublicKey, imageKitUrlEndpoint } from "../../helper";

type data = {
  name: string;
  description: string;
  logo: string;
  value: number;
  __v: number;
  _id: string;
};

interface handelFuncProps {
  handelClose: () => void;
  data?: data;
}

export default function AddnewCard(props: handelFuncProps) {
  const [url, setUrl] = useState(props.data?.logo || "");
  const [cardName, setCardName] = useState(props.data?.name || "");
  const [cardDesc, setCardDesc] = useState(props.data?.description || "");
  const [cardPoints, setCardPoints] = useState<number | string>(props.data?.value || "");
  const [cardUploadId, setCardUploadId] = useState("");
  const [cardPreviewImage, setCardPreviewImage] = useState<string>(props.data?.logo || "");
  const fileTypes = ["JPG", "PNG", "JPEG"];
  const maxFileSize = 10 * 1024 * 1024;

  const uri =
    process.env.NODE_ENV == "development"
      ? process.env.REACT_APP_DEV_URL
      : process.env.REACT_APP_URL;
  const notify = (data: String) => toast(data + "");

  const onError = (error: any) => {
    console.error("Image Upload Error:", {
      message: error.message,
      code: error.code,
      details: error
    });

    // More specific error toast
    if (error.response) {
      ERROR_TOAST(`Upload failed: ${error.response.status} ${error.response.statusText}`);
    } else if (error.request) {
      ERROR_TOAST("No response received from server. Check network connection.");
    } else {
      ERROR_TOAST("An unexpected error occurred during upload.");
    }
  };
  const onSuccess = (res: any) => {
    
    setCardUploadId(res.fileId);
    setUrl(res.url);
    setCardPreviewImage(res.thumbnailUrl || res.url); // Update preview image
  };

  const removeImage = () => {
    setUrl("");
    setCardUploadId("");
    setCardPreviewImage("");
  };

  const updateData = async () => {
    if (!props.data) return;

    const updatedData = {
      name: cardName,
      description: cardDesc,
      value: Number(cardPoints),
      logo: url,
    };

    try {
      await updatePoints(props.data._id, updatedData);
      props.handelClose(); // Close modal after update
      SUCCESS_TOAST("Data updated successfully!");
    } catch (error) {
      ERROR_TOAST("Failed to update data. Please try again.");
      console.error(error); // Optional: Log the error for debugging
    }
  };

  const handleClick = () => {
    return props.handelClose();
  };

  const ShowData = async () => {
    const payload = {
      name: cardName,
      description: cardDesc,
      value: Number(cardPoints),
      logo: url
    };

    try {
      const result = await createPoints(payload);
      

      if (result?.response?.statusCode === 200) {
        SUCCESS_TOAST("Card Created Successfully");
        setTimeout(() => {
          handleClick();
        }, 2000);
      } else {
        ERROR_TOAST(result?.response?.message || "Failed to Create Card");
      }
    } catch (error) {
      console.error("API Error:", error);
      ERROR_TOAST("Failed to create Card");
    }
  };

  const validateFile = (file: File) => {
    const fileExtension = file.name.split('.').pop()?.toUpperCase();

    if (!fileExtension || !fileTypes.includes(fileExtension)) {
      ERROR_TOAST(`Invalid file type. Allowed: ${fileTypes.join(', ')}`);
      return false;
    }

    if (file.size > maxFileSize) {
      ERROR_TOAST(`File too large. Max size: 10MB`);
      return false;
    }

    return true;
  };

  return (
    <>
      <Toaster
        toastOptions={{
          style: {
            color: "green",
          },
        }}
      />
      <div className="addCourse">
        <div className="fullDescCard">
          <div className="headerAC">
            <h2>{props.data ? "Update Card" : "Create New Card"}</h2>
            <div
              className="top-svg"
              onClick={() => handleClick()}
              style={{ cursor: "pointer" }}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 0C18.9782 0 22.7936 1.58035 25.6066 4.3934C28.4196 7.20644 30 11.0218 30 15C30 18.9782 28.4196 22.7936 25.6066 25.6066C22.7936 28.4196 18.9782 30 15 30C11.0218 30 7.20644 28.4196 4.3934 25.6066C1.58035 22.7936 0 18.9782 0 15C0 11.0218 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0218 0 15 0ZM15 13.1807L11.5157 9.69643C11.2745 9.45518 10.9473 9.31964 10.6061 9.31964C10.2649 9.31964 9.93768 9.45518 9.69643 9.69643C9.45518 9.93768 9.31964 10.2649 9.31964 10.6061C9.31964 10.9473 9.45518 11.2745 9.69643 11.5157L13.1807 15L9.69643 18.4843C9.57697 18.6037 9.48221 18.7456 9.41757 18.9016C9.35292 19.0577 9.31964 19.225 9.31964 19.3939C9.31964 19.5629 9.35292 19.7301 9.41757 19.8862C9.48221 20.0423 9.57697 20.1841 9.69643 20.3036C9.81588 20.423 9.9577 20.5178 10.1138 20.5824C10.2699 20.6471 10.4371 20.6804 10.6061 20.6804C10.775 20.6804 10.9423 20.6471 11.0984 20.5824C11.2544 20.5178 11.3963 20.423 11.5157 20.3036L15 16.8193L18.4843 20.3036C18.6037 20.423 18.7456 20.5178 18.9016 20.5824C19.0577 20.6471 19.225 20.6804 19.3939 20.6804C19.5629 20.6804 19.7301 20.6471 19.8862 20.5824C20.0423 20.5178 20.1841 20.423 20.3036 20.3036C20.423 20.1841 20.5178 20.0423 20.5824 19.8862C20.6471 19.7301 20.6804 19.5629 20.6804 19.3939C20.6804 19.225 20.6471 19.0577 20.5824 18.9016C20.5178 18.7456 20.423 18.6037 20.3036 18.4843L16.8193 15L20.3036 11.5157C20.423 11.3963 20.5178 11.2544 20.5824 11.0984C20.6471 10.9423 20.6804 10.775 20.6804 10.6061C20.6804 10.4371 20.6471 10.2699 20.5824 10.1138C20.5178 9.9577 20.423 9.81588 20.3036 9.69643C20.1841 9.57697 20.0423 9.48221 19.8862 9.41757C19.7301 9.35292 19.5629 9.31964 19.3939 9.31964C19.225 9.31964 19.0577 9.35292 18.9016 9.41757C18.7456 9.48221 18.6037 9.57697 18.4843 9.69643L15 13.1807Z"
                  fill="#8E8EA1"
                />
              </svg>
            </div>
          </div>
          <div className="ac-border-top"></div>
          <div className="ad-body">
            <div className="previous-drop">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Card Name*
                </label>
                <input
                  type="text"
                  value={cardName}
                  name="card_name"
                  className="setCard form-control dropdown-toggle"
                  onChange={(e) => setCardName(e.target.value)}
                />
              </div>
              <div className="dropdown">
                <label className="cat-hello" htmlFor="points">
                  Points*
                </label>
                <input
                  type="number"
                  value={cardPoints}
                  name="card_points"
                  min="0"
                  className="setCard form-control dropdown-toggle"
                  onChange={(e) => {
                    const value = e.target.value;
                    setCardPoints(value === '0' ? '' : value);
                  }}
                  placeholder="Enter points"
                />
              </div>
            </div>
          </div>
          <div className="ac-body">
            <div className="previous-drop">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Card Description*
                </label>
                <input
                  type="text"
                  name="course_name"
                  value={cardDesc}
                  className="setCard form-control dropdown-toggle"
                  onChange={(e) => setCardDesc(e.target.value)}
                />
              </div>
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Upload Card*
                </label>
                <br />
                <IKContext
                  publicKey={imageKitPublicKey}
                  urlEndpoint={imageKitUrlEndpoint}
                  authenticationEndpoint={uri + `/card/auth`}
                >
                  {cardPreviewImage ? (
                    <div className="uploaded-preview-container">
                      <div className="uploaded-preview-box">
                        <img
                          src={cardPreviewImage}
                          alt="Uploaded preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <button className="remove-button" onClick={removeImage}>
                        Remove
                      </button>
                    </div>
                  ) : (
                    <div className="upload-area">
                      <div className="upload-icon">
                        <Upload />
                      </div>
                      <div className="upload-text">
                        <p>Upload or drag & drop files here</p>
                        <p id="upload-text-second">JPG, PNG up to 10mb</p>
                      </div>
                      <IKUpload
                        fileName="my-upload"
                        onError={onError}
                        onSuccess={onSuccess}
                        validate={validateFile}
                      />
                    </div>
                  )}
                </IKContext>
              </div>
            </div>
          </div>
          <div className="drag-drop-top-line mt-5"></div>
          <div className="down-buttons d-flex">
            <button
              className={`create-button`}
              disabled={
                cardDesc == "" ||
                cardName == "" ||
                cardPoints == 0 ||
                url == ""
              }
              onClick={() => {
                props.data ? updateData() : ShowData();
              }}
            >
              {props.data ? "Update Card" : "Create New Card"}
            </button>
            <button className="cancel-button" onClick={() => handleClick()}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}